export const STATUS_CODE = {
  OK: 0
} as const
export type STATUS_CODE = (typeof STATUS_CODE)[keyof typeof STATUS_CODE]
